<template>
 <NotificationGroup group="error">
        <Notification
          :maxNotifications="1"
          v-slot="{ notifications, close }"
          enter="transform ease-out duration-300 transition"
          enter-from="translate-y-2 opacity-0 translate-y-0 translate-x-4"
          enter-to="translate-y-0 opacity-100 translate-x-0"
          leave="transition ease-in duration-500"
          leave-from="opacity-100"
          leave-to="opacity-0"
          move="transition duration-500"
          move-delay="delay-300"
        >
          <div
            class="fixed w-full right-0 md:mt-5 md:mr-5 z-50 md:max-w-md bg-red-700 dark:bg-red-950 border-l-4 border-neg rounded"
            v-for="notification in notifications"
            :key="notification.id"
          >
            <div class="flex justify-end -mb-3 p-4">
              <h2 class="text-red-100 dark:text-red-200">{{ notification.title ? notification.title : t.GENERAL_ERROR }}</h2>
              <button
                type="button"
                class="cursor-pointer bg-transparent rounded text-sm ml-auto inline-flex items-center"
                @click="close(notification.id)"
              >
                <svg
                  class="table-cell w-6 h-6 text-red-100 hover:opacity-80 -mt-1"
                  :aria-label="t.GENERAL_CLOSE"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>
            <div class="px-4 pb-4">
              <p class="text-red-300 break-words" v-html="notification.text ? notification.text : t.GENERAL_ERROR_CONTACTUS"></p>
            </div>

            <div v-if="notification.to && notification.toTitle" class="px-4 pb-4 justify-end">
              <router-link class="ctaBg w-full p-2 max-w-sm" @click="close(notification.id)" :to="notification.to">{{ notification.toTitle }}</router-link>
            </div>
          </div>
        </Notification>
  </NotificationGroup> 

  <NotificationGroup group="success">
        <Notification
          :maxNotifications="1"
          v-slot="{ notifications, close }"
          enter="transform ease-out duration-300 transition"
          enter-from="translate-y-2 opacity-0 translate-y-0 translate-x-4"
          enter-to="translate-y-0 opacity-100 translate-x-0"
          leave="transition ease-in duration-500"
          leave-from="opacity-100"
          leave-to="opacity-0"
          move="transition duration-500"
          move-delay="delay-300"
        >
          <div
            class="fixed w-full right-0 md:mt-5 md:mr-5 z-50 md:max-w-md bg-green-700 dark:bg-green-900 border-l-4 border-pos rounded"
            v-for="notification in notifications"
            :key="notification.id"
          >
            <div class="flex justify-end -mb-3 p-4">
              <h2 class="text-green-100 dark:text-green-200">{{ notification.title ? notification.title : t.GENERAL_SUCCESS }}</h2>
              <button
                type="button"
                class="cursor-pointer bg-transparent rounded text-sm ml-auto inline-flex items-center"
                @click="close(notification.id)"
              >
                <svg
                  class="table-cell w-6 h-6 text-green-100 hover:opacity-80 -mt-1"
                  :aria-label="t.GENERAL_CLOSE"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>
            <div class="px-4 pb-4">
              <p class="text-green-300 break-words" v-html="notification.text"></p>
            </div>

            <div v-if="notification.to && notification.toTitle" class="px-4 pb-4 justify-end">
              <router-link class="ctaBg w-full p-2 max-w-sm" @click="close(notification.id)" :to="notification.to">{{ notification.toTitle }}</router-link>
            </div>
          </div>
        </Notification>
  </NotificationGroup>

  <NotificationGroup group="info">
        <Notification
          :maxNotifications="1"
          v-slot="{ notifications, close }"
          enter="transform ease-out duration-300 transition"
          enter-from="translate-y-2 opacity-0 translate-y-0 translate-x-4"
          enter-to="translate-y-0 opacity-100 translate-x-0"
          leave="transition ease-in duration-500"
          leave-from="opacity-100"
          leave-to="opacity-0"
          move="transition duration-500"
          move-delay="delay-300"
        >
          <div
            class="fixed w-full right-0 md:mt-5 md:mr-5 z-50 md:max-w-md bg-gray-100 dark:bg-gray-900 border-l-4 border-gray-300 dark:border-gray-700 rounded"
            v-for="notification in notifications"
            :key="notification.id"
          >
            <div class="flex justify-end -mb-3 p-4">
              <h2 class="text-gray-500">{{ notification.title ? notification.title : t.GENERAL_INFO }}</h2>
              <button
                type="button"
                class="cursor-pointer bg-transparent rounded text-sm ml-auto inline-flex items-center"
                @click="close(notification.id)"
              >
                <svg
                  class="table-cell w-6 h-6 text-gray-700 dark:text-gray-100 hover:opacity-80 -mt-1"
                  :aria-label="t.GENERAL_CLOSE"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>
            <div class="px-4 pb-4">
              <p class="text-gray-400 break-words" v-html="notification.text ? notification.text : t.GENERAL_ERROR_CONTACTUS"></p>
            </div>

            <div v-if="notification.to && notification.toTitle" class="px-4 pb-4 justify-end">
              <router-link class="ctaBg w-full p-2 max-w-sm" @click="close(notification.id)" :to="notification.to">{{ notification.toTitle }}</router-link>
            </div>
          </div>
        </Notification>
  </NotificationGroup> 
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { setT } from "@commons/composables/utils";

export default defineComponent({
  name: "notificationsComponent",
  setup() {
    const t = ref({} as any)
    const translationKeys = {"en_US":{"GENERAL_ERROR_CONTACTUS":"Sorry, an error has occurred. Please try again later or contact our support team.","GENERAL_SUCCESS":"Success","GENERAL_CLOSE":"Close","GENERAL_ERROR":"Error","GENERAL_INFO":"Info","GENERAL":"General"}};
    t.value = setT(translationKeys);

    return {
      t,
    }
  },
});
</script>
